<template>
  <v-dialog width="600" v-model="showLogs">
    <v-card class="logsContainer">
      <v-card-title class="secondary white--text">
        <span>Draft Sub-hire Logs {{ draftSubHire && draftSubHire.dsh_no }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="showLogs = false">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-3" />
        <v-timeline dense clipped v-if="logs.length">
          <v-timeline-item v-for="log in logs" :key="log.id" icon-color="primary" small>
            <v-card class="elevation-2">
              <v-card-title class="py-0">
                <v-row>
                  <v-col cols="6">
                    <span class="text-subtitle-2">{{ log.updated_by || "System" }}</span>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <span class="text-caption">{{ $globals.formatDate(log.created, true) }}</span>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>{{ log.message }}</v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <div v-else-if="!loading" class="text-center grey--text py-6">No logs yet.</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    draftSubHire: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      logs: [],
    };
  },
  computed: {
    showLogs: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(val) {
      if (val && this.draftSubHire) {
        this.getLogs();
      }
    },
  },
  methods: {
    getLogs() {
      this.loading = true;
      this.logs = [];
      this.$api.draftSubHire
        .getDraftSubHireObject(this.draftSubHire.id)
        .then((res) => {
          const data = res.data || res;
          this.logs = data.logs || [];
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
